import { createContext, useEffect, useState } from 'react';
import DataSource from 'devextreme/data/data_source';
import { CreateAuthorizedDataSource } from '~/helpers/data';

export const CallLogLookupsContext = createContext({
  usersData: [],
  categories: [],
  categoriesData: null,
  subcategories: [],
  actionsData: null,
  involvementTypes: [],
  isLoaded: false,
});

async function loadLookups() {
  const base = window.env.apiEndpoint;

  const load = (url, key, params) => {
    const ds = CreateAuthorizedDataSource({ loadUrl: url }, params, key, false);
    return ds.load().then(data => { ds.dispose(); return data; });
  };

  const [users, categories, subcategories, actions, involvementTypes] = await Promise.all([
    load(`${base}/api/v1/Users/Get`, 'Id'),
    load(`${base}/api/v1/CallLogCategories/CallLogCategoriesLookup`, 'Value'),
    load(`${base}/api/v1/CallLogSubCategories/CallLogSubCategoriesLookup`, 'Value', { load: { categoryId: 0 } }),
    load(`${base}/api/v1/CallLogActions/CallLogActionsLookup`, 'Value'),
    load(`${base}/api/v1/InvolvementTypes/InvolvementTypesLookup`, 'Value'),
  ]);

  return {
    usersData: users,
    categories,
    categoriesData: new DataSource({ store: categories, group: 'Header' }),
    subcategories,
    actionsData: new DataSource({ store: actions, group: 'Header' }),
    involvementTypes,
    isLoaded: true,
  };
}

export function CallLogLookupsProvider({ children }) {
  const [lookups, setLookups] = useState({
    usersData: [],
    categories: [],
    categoriesData: null,
    subcategories: [],
    actionsData: null,
    involvementTypes: [],
    isLoaded: false,
  });

  useEffect(() => {
    let cancelled = false;
    loadLookups()
      .then(data => { if (!cancelled) setLookups(data); })
      .catch(console.error);
    return () => { cancelled = true; };
  }, []);

  return (
    <CallLogLookupsContext.Provider value={lookups}>
      {children}
    </CallLogLookupsContext.Provider>
  );
}
